/**
 * Build the absolute OAuth / email-link callback URL, respecting the app base path.
 */
export function getAuthCallbackUrl(next?: string): string {
  const base = __BASE_PATH__ === '/' ? '' : __BASE_PATH__;
  let url = `${window.location.origin}${base}/auth/callback`;
  if (next) {
    url += `?next=${encodeURIComponent(next)}`;
  }
  return url;
}

/**
 * Validate an ordinary (non-recovery) post-auth destination.
 * Only same-origin internal paths are allowed; auth workflow routes are rejected.
 */
export function validateOrdinaryPostAuthNext(next: string | null | undefined): string {
  if (!next) return '/';
  if (!next.startsWith('/') || next.startsWith('//')) return '/';
  if (next.includes('://') || next.includes('\\')) return '/';

  const lower = next.toLowerCase();
  if (
    lower === '/auth' ||
    lower.startsWith('/auth/') ||
    lower.startsWith('/login') ||
    lower.startsWith('/register') ||
    lower.startsWith('/signup')
  ) {
    return '/';
  }

  return next;
}